/* eslint-disable import/prefer-default-export */
import { isSameDay } from '@utils/dates';

export const calculateStreaks = (dailyTasks) => {
  const dailyTasksCount = dailyTasks.length;
  const dailyTasksCopy = dailyTasks;
  const today = new Date();
  for (let index = dailyTasksCount - 1; index >= 0; index -= 1) {
    const dailyTask = dailyTasksCopy[index];
    const isToday = isSameDay(new Date(dailyTask.date), today);
    const isInStreak = dailyTask.isCompleted;
    const isInOngoingStreak =
      (isInStreak &&
        (isToday ||
          index === dailyTasksCount - 1 ||
          dailyTasksCopy[index + 1].is_today ||
          dailyTasksCopy[index + 1].is_in_ongoing_streak)) ||
      false;
    const end =
      (isInStreak &&
        (index === dailyTasksCount - 1 ||
          !dailyTasksCopy[index + 1].isCompleted)) ||
      false;
    const start =
      (isInStreak && (index === 0 || !dailyTasksCopy[index - 1].isCompleted)) ||
      false;

    dailyTask.is_today = isToday;
    dailyTask.is_in_streak = isInStreak;
    dailyTask.is_in_ongoing_streak = isInOngoingStreak;
    dailyTask.end = end;
    dailyTask.start = start;
  }
  return dailyTasksCopy;
};
